'use client';

import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';
import { Button } from '@/shared/ui/button';
import { Modal } from '@/shared/ui/modal';
import { ModalProps } from '@/shared/ui/modal/types';
import './confirm-delete-address-modal.scss';

type Props = ModalProps & {
    addressName: string;
    onConfirm: () => void;
    children?: ReactNode;
};

export const ConfirmDeleteAddressModal = ({ addressName, onConfirm, onClose, ...props }: Props) => {
    const t = useTranslations();

    const handleConfirm = () => {
        onConfirm();
        onClose();
    };

    return (
        <Modal
            {...props}
            onClose={onClose}
            wrapperProps={{
                className: 'confirm-delete-address-modal',
                containerProps: {
                    className: 'confirm-delete-address-modal__container',
                },
                'data-testid': 'confirm-delete-address-modal',
            }}
        >
            <Modal.Title
                className="confirm-delete-address-modal__title"
                data-testid="confirm-delete-address-modal-title"
            >
                {t('CONFIRM_DELETE_ADDRESS_MODAL.TITLE')}
            </Modal.Title>
            <Modal.Description
                className="confirm-delete-address-modal__description"
                data-testid="confirm-delete-address-modal-description"
            >
                {t('CONFIRM_DELETE_ADDRESS_MODAL.DESCRIPTION', { addressName })}
            </Modal.Description>
            <div className="confirm-delete-address-modal__buttons">
                <Button
                    variant="secondary"
                    onClick={() => onClose()}
                    data-testid="confirm-delete-address-modal-cancel-button"
                    className="confirm-delete-address-modal__button"
                >
                    {t('WORDS.CANCEL')}
                </Button>
                <Button
                    variant="default"
                    onClick={handleConfirm}
                    data-testid="confirm-delete-address-modal-confirm-button"
                    className="confirm-delete-address-modal__button confirm-delete-address-modal__button--delete"
                >
                    {t('WORDS.DELETE')}
                </Button>
            </div>
        </Modal>
    );
};
